import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/venue-application")({
  component: () => <Navigate to="/partner-apply" replace />,
});
